import { render, staticRenderFns } from "./ViewDrawer.vue?vue&type=template&id=2ddad9c5&scoped=true&"
import script from "./ViewDrawer.vue?vue&type=script&lang=js&"
export * from "./ViewDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ViewDrawer.vue?vue&type=style&index=0&id=2ddad9c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddad9c5",
  null
  
)

export default component.exports